import React, { useMemo } from 'react';
import { TeamEntity } from '@shared/models/team.models';
import { PrimaryButton } from "./PrimaryButton";
import { OutlineButton } from "./OutlineButton";
import { ButtonSize } from "./ButtonStyling";
import { isInCompanyTab, isInTeamsSettingsTab, isInTeamsTab } from '@shared/utils/TeamsUtils';
import { canUserEditTeam } from '@shared/utils/AccessControl';
import { useSelector } from "react-redux";
import { selectCurrentUser, selectIsInTeams } from '@shared/store/auth.duck';

interface Props {
  team?: TeamEntity;
  buttonStyle?: 'outline' | 'primary';
  size?: ButtonSize;
  style?: any;
  disabled?: boolean;
  fullWidth?: boolean;
}

export function AddTeamMemberButton(props: Props) {
  const buttonStyle = props.buttonStyle || 'outline';
  const fullWidth = props.fullWidth ?? true;
  const currentUser = useSelector(selectCurrentUser);
  const canEditTeam = canUserEditTeam(currentUser, props.team);
  const isInTeams = useSelector(selectIsInTeams);

  const link = useMemo(() => {
    if (!isInTeams || isInTeamsSettingsTab()) {
      return '/manage/add-users';
    } else if (isInCompanyTab()) {
      return '/whereabouts/company/add-users'
    } else if (isInTeamsTab()) {
      return '/whereabouts/team/add-users'
    } else {
      return '/manage/add-users';
    }
  }, [isInTeams])

  if (!canEditTeam) {
    return null;
  }

  if (buttonStyle === 'primary') {
    return (
      <PrimaryButton dataTest="addTeamMember-button" size={props?.size ?? ButtonSize.Medium}
                     text={!!props.team ? 'settings.button-add-team-member' : 'settings.button-add-user'}
                     style={props.style ?? {}}
                     fullWidth={fullWidth}
                     disabled={props?.disabled}
                     link={link} />
    )
  } else {
    return (
      <OutlineButton dataTest="addTeamMember-button" size={props?.size ?? ButtonSize.Medium}
                     text={!!props.team ? 'settings.button-add-team-member' : 'settings.button-add-user'}
                     link={link}
                     disabled={props?.disabled}
                     fullWidth={fullWidth}
                     style={props.style ?? {}} />
    )
  }
}
